module.exports = __webpack_public_path__ + "img/logoHorizontal.880b13b2.svg";